__turbopack_context__.v({
  "checkbox": "Checkbox-module__QLp5MW__checkbox",
  "container": "Checkbox-module__QLp5MW__container",
  "description": "Checkbox-module__QLp5MW__description",
  "disabled": "Checkbox-module__QLp5MW__disabled",
  "error": "Checkbox-module__QLp5MW__error",
  "errorText": "Checkbox-module__QLp5MW__errorText",
  "icon": "Checkbox-module__QLp5MW__icon",
  "indicator": "Checkbox-module__QLp5MW__indicator",
  "label": "Checkbox-module__QLp5MW__label",
  "labelLeft": "Checkbox-module__QLp5MW__labelLeft",
  "labelText": "Checkbox-module__QLp5MW__labelText",
});
